export interface BgtUserInput {
  patientCode: string;
  birthDate: string;
  birthConfirm: string;
  /** 수정 모드에서 생년월일을 건드리지 않았다면 확인 입력을 요구하지 않는다 */
  requireConfirm: boolean;
}

export interface BgtUserInputErrors {
  patientCode?: string;
  birthDate?: string;
  birthConfirm?: string;
}

const BIRTH_PATTERN = /^\d{8}$/;

/**
 * BGT 회원 입력 검증 — 등록 폼과 수정 다이얼로그가 같이 쓴다.
 *
 * 환자번호 + 생년월일이 곧 앱 로그인 정보라(haha_back_bgt auth.service.ts `patient()`)
 * 한 글자가 틀리면 그 대상자는 로그인하지 못한다. 생년월일을 두 번 받아 단순 오타를
 * 입력 시점에 잡는다.
 */
export function validateBgtUserInput(values: BgtUserInput): BgtUserInputErrors {
  const errors: BgtUserInputErrors = {};

  if (!values.patientCode.trim()) {
    errors.patientCode = '환자번호를 입력해 주세요';
  } else if (/\s/.test(values.patientCode)) {
    errors.patientCode = '환자번호에 공백을 넣을 수 없습니다';
  } else if (values.patientCode.length > 10) {
    errors.patientCode = '환자번호는 10자 이하입니다';
  }

  if (!BIRTH_PATTERN.test(values.birthDate)) {
    errors.birthDate = '생년월일 8자리(YYYYMMDD)를 입력해 주세요';
  }

  if (values.requireConfirm && values.birthDate !== values.birthConfirm) {
    errors.birthConfirm = '생년월일이 서로 다릅니다';
  }

  return errors;
}

/** 숫자만 8자리까지 — 입력 도중에도 형식을 벗어나지 않게 한다 */
export function normalizeBirthInput(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, 8);
}
